export var PlaybackStateFilter;
(function (PlaybackStateFilter) {
    PlaybackStateFilter[PlaybackStateFilter["ALL"] = 0] = "ALL";
    PlaybackStateFilter[PlaybackStateFilter["DOWNLOADED"] = 1] = "DOWNLOADED";
    PlaybackStateFilter[PlaybackStateFilter["UNPLAYED"] = 2] = "UNPLAYED";
})(PlaybackStateFilter || (PlaybackStateFilter = {}));
//# sourceMappingURL=PlaybackStateFilter.js.map